import { CardHeader } from "reactstrap";
import { H3, SVG } from "../../../../AbstractElements";
import { Visitors } from "../../../../Constant";
import DropdownCommon from "./Common/DropdownCommon";
import { DAILY_DROPDOWN } from "../../../../Data/Widgets/GeneralWidgets";

const VisitorsCardHeader = () => {
  return (
    <CardHeader className="card-no-border pb-0">
      <div className="header-top">
        <H3 className="m-0">
          {Visitors}
          <span className="f-14 font-primary f-w-500 ms-1">
            <SVG iconId="user-visitor" className="svg-fill me-1" />(+2.8)
          </span>
        </H3>
        <div className="card-header-right-icon">
          <DropdownCommon icon iconName="icon-more-alt" dropdownMain={{ className: "icon-dropdown", direction: "start" }} options={DAILY_DROPDOWN} btn={{ tag: "span" }}/>
        </div>
      </div>
    </CardHeader>
  );
};

export default VisitorsCardHeader;
